export const relationSPUCategory = {
    HojaMediador: { 
        group: "Hoja información previa del mediador",
        column: 0,
        order: 1
    },
    "\"ProyectosEmisiones#": { 
        group: "Proyectos y emisiones",
        column: 0,
        order: 2
    },
    ProyectosEmisiones: { 
        group: "Proyectos y emisiones",
        column: 0,
        order: 2
    },
    "\"SegurosParticulares#": { 
        group: "Seguros particulares",
        column: 0,
        order: 3
    },
    SegurosParticulares: { 
        group: "Seguros particulares",
        column: 0,
        order: 3
    },
    SegurosEmpresas: { 
        group: "Seguros empresas",
        column: 0,
        order: 4
    },
    SegurosVidaSaludDecesos: { 
        group: "Seguros vida, salud y decesos",
        column: 1,
        order: 1
    },
    "\"SegurosVidaSaludDecesos#": { 
        group: "Seguros vida, salud y decesos",
        column: 1,
        order: 1
    },
    Agroseguro: { 
        group: "Agroseguro",
        column: 1,
        order: 2
    },
    OtrosServicios: { 
        group: "Otros Servicios",
        column: 1,
        order: 3
    }
};